import { GeneralModel } from "./general.model";
export class Size extends GeneralModel{
    id: number;
    code: string;
    name: string;
    width: number;
    height: number;
    length: number;
    isPackage: boolean;
    isBox : boolean;
    isEnabled: boolean = true;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/size.model.ts